import React, { Fragment } from 'react';
import Script from 'next/script';
import { Dialog, Transition } from '@headlessui/react';

declare global {
  interface Window {
    Calendly: {
      // eslint-disable-next-line no-unused-vars, @typescript-eslint/no-explicit-any
      initInlineWidget: (state: any) => void;
    };
  }
}

const CalendlyForm = ({
  isOpen,
  onClose,
  fullName,
  email,
  companyName,
  phoneNumber,
}: {
  isOpen: boolean;
  onClose: () => void;
  fullName: string;
  email: string;
  companyName: string;
  phoneNumber: string;
}) => {
  return (
    <>
      <Script
        src="https://assets.calendly.com/assets/external/widget.js"
        type="text/javascript"
        onLoad={() => {
          window?.Calendly?.initInlineWidget({
            url:
              'https://calendly.com/elioralayev/real-estate-professionals?name=' +
              fullName +
              '&email=' +
              email +
              '&a1=' +
              companyName +
              '&phone_number=1' +
              phoneNumber,
            parentElement: document.getElementById('calendly-div'),
            prefill: {},
            utm: {},
          });
        }}
      />
      <Transition.Root show={isOpen} as={Fragment}>
        <Dialog as="div" className="relative z-[100]" onClose={onClose}>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black-dark/30 transition-opacity backdrop-blur-[1px]" />
          </Transition.Child>

          <div className="lg fixed inset-0 z-10">
            <div className="flex min-h-full items-center justify-center transition-all sm:my-8 w-full sm:w-full max-w-full">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <div
                  id="calendly-div"
                  className="flex w-full h-full min-h-full"
                  style={{ height: '800px' }}
                ></div>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition.Root>
    </>
  );
};

export default CalendlyForm;
